module.exports = __webpack_public_path__ + "img/nopic.6fa4f7db.png";